import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvCheckChargerResponse } from '../../../../../core/models/ev.model';

@Component({
    selector: 'app-modal-ev-charger-check-status',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './modal-ev-charger-check-status.component.html',
    styleUrl: './modal-ev-charger-check-status.component.css'
})
export class ModalEvChargerCheckStatusComponent {
    @Input() isOpen: boolean = false;
    @Input() data: EvCheckChargerResponse | null = null;
    @Output() onClose = new EventEmitter<void>();

    closeModal() {
        this.isOpen = false;
        this.onClose.emit();
    }
}
